import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'CHOISISSEZ',
  description: 'Choisissez la notion, le thème ou le besoin de votre classe.'
}, {
  number: '02',
  title: 'OUVREZ',
  description: 'Ouvrez le volume ou la ressource correspondante.'
}, {
  number: '03',
  title: 'ENSEIGNEZ',
  description: 'Imprimez, projetez ou utilisez directement le support selon les besoins de votre classe.'
}];
export function HowItWorks() {
  return <section className="w-full bg-paper px-5 py-6 sm:py-12" data-id="element-146" data-mp="qibjniqq2hhx">
      <div className="mx-auto max-w-5xl" data-id="element-147" data-mp="crya5by6muqh">
        <div className="mx-auto max-w-2xl text-center" data-id="element-148" data-mp="cr6puxa1cjfi">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-149" data-mp="gtjrpalnvx70">
            Choisissez. Ouvrez. Enseignez.
          </h2>
          <p className="mt-2 text-sm text-ink/70 sm:mt-3 sm:text-base" data-id="element-150" data-mp="14hkv653zgnfk">
            Trois étapes entre le besoin de votre classe et le support projeté ou imprimé.
          </p>
        </div>

        <div className="mt-6 flex flex-col gap-3 sm:mt-10 md:flex-row md:gap-6" data-id="element-151" data-mp="2rm7gywxq7hdh">
          {steps.map((step, i) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-1 items-center gap-4 rounded-xl bg-white p-4 shadow-sm sm:flex-col sm:p-6 sm:text-center" data-id="element-152" data-mp="2mki3zbqy0tmr" data-mpi={i}>
              <span className="font-serif-display text-3xl font-bold text-cobalt sm:text-4xl" data-id="element-153" data-mp="3ka39dpg9in4g">
                {step.number}
              </span>
              <div data-id="element-154" data-mp="3fbs1hk9j2mov">
                <h3 className="text-sm font-bold text-ink sm:mt-2 sm:text-lg" data-id="element-155" data-mp="3f95txkmn076n">{step.title}</h3>
                <p className="mt-1 text-[13px] leading-relaxed text-ink/70 sm:mt-2 sm:text-sm" data-id="element-156" data-mp="1pwkfqqpcroof">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-6 text-center sm:mt-8" data-id="element-157" data-mp="3pyk2gyimny5d">
          <p className="text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-158" data-mp="3pzd1tef9bldh">
            Vous gardez votre liberté pédagogique.
          </p>
          <p className="mt-1 text-sm text-ink/70 sm:mt-2 sm:text-base" data-id="element-159" data-mp="3u2i1zabv7ayy">
            Vous gardez votre façon d’enseigner. Vous gagnez simplement une base déjà prête.
          </p>
        </div>
      </div>
    </section>;
}